export default function CouncilMeetingAgenda() {
    return (
        <div className="accordion-item">
        <h2 className="accordion-header">
            <button className="accordion-button caret-off collapsed meeting-item-green" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMeetingItem">
                <i className="fa-solid fa-people-group fa-2xl feature-icon af-icon"></i>
                <b>October 20, 2026 Council Meeting Agenda &amp; Live Stream Link Now Available&nbsp;</b>
                <h5><span className="badge bg-light text-dark badge-custom">Meeting</span></h5>
            </button>
        </h2>
        <div id="collapseMeetingItem" className="accordion-collapse collapse" data-bs-parent="#latestNewsAccordion">
            <div className="accordion-body">
                <p>
                    <b>Meeting Agenda:</b>
                </p>
                <p>
                    <a href="docs/council/minutes/2026/2026-10-20-BCAgenda.pdf" target="_blank" rel="noopener noreferrer"><i className="fa-solid fa-file-pdf fa-xl">
                        </i>&nbsp;October 20, 2026 Council Meeting agenda.</a>
                </p>
                <p>
                    <b>Live Stream:</b>
                </p>
                <p>
                    <a href="https://stream.lifesizecloud.com/extension/7006865/701aaf40-9042-4e66-adbe-12aeb894b216">CLICK HERE TO ACCESS THE COUNCIL MEETING LIVE STREAM&nbsp;<i className="fa-solid fa-video"></i></a>
                </p>
            </div>
        </div>
    </div>
    )
}